import {useEffect} from "react";

/**
 * A custom hook that triggers a callback when a click event happens outside the specified ref element.
 *
 * @param {React.RefObject<HTMLElement>} ref A reference to the target element to monitor for outside clicks.
 * @param {() => void} callback The function to be called when a click outside the target element occurs.
 * @param {React.RefObject<HTMLElement>[]} [excludedRef=[]] An optional list of references to elements that should be excluded from the outside click detection.
 * @return {void} Does not return any value.
 */
function useOutsideClick(ref: any, callback: () => void, excludedRef: React.RefObject<HTMLElement>[] = []) {
    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            const target = event.target as Node;
            if (ref.current && !ref.current.contains(target)
                && !excludedRef.some(exr => exr.current?.contains(target))
            ) {
                callback()
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
}

export default useOutsideClick